import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const auditDetail = listeners["auditDetail"] || function () { };

  const auditStatusArr = ["审核中", "审核通过", "审核不通过"];

  const AuditStatus = ({ props: { vo } }) => {
    const auditStatusName = auditStatusArr[vo.row.auditStatus];
    return <div domPropsInnerHTML={auditStatusName}></div>;
  };
  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    let dealConf = [];

    dealConf.push(["icon-audit-detail", "审核详情", () => auditDetail(curItem), "topicLecture:queryDeclare"])
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      width: "110"
    },
    {
      label: "工作单位",
      prop: "deptName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "150"
    },
    {
      label: "讲座主题",
      prop: "lectureName",
      width: "150"
    },
    {
      label: "授课老师",
      prop: "teacher",
      width: "90"
    },
    {
      label: "授课老师职务",
      prop: "teacherUnitPosition",
      width: "150"
    },
    {
      label: "讲座时间",
      prop: "trainTimeStr",
      width: "180",
      showOverflowTooltip: true
    },
    {
      label: "学时",
      prop: "lectureHours",
      width: "80"
    },
    {
      label: "审核状态",
      prop: "auditStatus",
      width: "80",
      render: vo => <AuditStatus vo={vo} />
    },
    {
      label: "申请时间",
      prop: "createDate",
      width: "160"
    },
    {
      label: "操作",
      width: "80",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
